import { Breakpoint } from '@mui/material';

export const DEFAULT_MAX_WIDTH: Breakpoint = 'xs';
